const ldapAttributes = [
  'displayName', 'givenName', 'sn', 'mail', 'userPrincipalName', 'department',
  'title', 'telephoneNumber', 'mobile', 'employeeID', 'sAMAccountName',
  'userAccountControl', 'distinguishedName', 'description', 'physicalDeliveryOfficeName',
  'company', 'manager', 'extensionAttribute1', 'extensionAttribute2', 'extensionAttribute3',
]
const entraAttributes = [
  'id', 'userPrincipalName', 'mail', 'displayName', 'givenName', 'surname',
  'department', 'jobTitle', 'mobilePhone', 'businessPhones', 'employeeId', 'accountEnabled',
]
const entraAliases = {
  sn: 'surname', title: 'jobTitle', mobile: 'mobilePhone', telephoneNumber: 'businessPhones',
  employeeID: 'employeeId', sAMAccountName: 'userPrincipalName', userAccountControl: 'accountEnabled',
}
export const isEntra = (source) => source?.type?.toUpperCase() === 'ENTRA'
export const directoryAttributes = (source) => isEntra(source) ? entraAttributes : ldapAttributes

export function initialDirectoryMappings(source) {
  const defaults = {
    EnglishName: 'displayName', ArabicName: 'displayName', Email: 'mail', DepartmentId: 'department',
    Mobile: 'mobile', Phone: 'telephoneNumber', EmployeeId: 'employeeID',
    Username: 'sAMAccountName', Resigned: 'userAccountControl',
    Attribute1: isEntra(source) ? 'jobTitle' : 'Unbound',
    Attribute2: 'Unbound', Attribute3: 'Unbound', Attribute4: 'Unbound', Attribute5: 'Unbound',
  }
  const saved = {}
  // Existing LDAP sources keep absent mappings unbound, just like the V6 reader.
  // Opening and saving the editor must not silently opt additional fields into sync.
  if (!isEntra(source) && source?.id) {
    for (const key of Object.keys(defaults)) {
      if (key !== 'Username' && key !== 'Resigned') defaults[key] = 'Unbound'
    }
  }
  for (const item of source?.profileAttributesMapping || []) {
    const key = item.builtInAttributeName ?? item.BuiltInAttributeName
    const value = (item.dataSourceFieldName ?? item.DataSourceFieldName ?? '').trim()
    if (key) saved[key] = !value || value.toLowerCase() === 'unbound' ? 'Unbound' : value
  }
  if (saved.Attribute1 === undefined && saved.JobTitle !== undefined) saved.Attribute1 = saved.JobTitle
  const mappings = { ...defaults, ...saved }
  delete mappings.JobTitle
  if (isEntra(source)) {
    for (const key of Object.keys(mappings)) mappings[key] = entraAliases[mappings[key]] || mappings[key]
  }
  return mappings
}

export function directoryMappingPayload(mappings) {
  return Object.entries(mappings).map(([key, value]) => ({
    BuiltInAttributeName: key, DataSourceFieldName: value?.trim() || 'Unbound',
  }))
}
